import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  { path: '', name: 'signin', component: () => import('@/views/auth/Signin.vue') },
  {
    path: '/company/login',
    name: 'SignInAdmin',
    component: () => import('@/views/auth/SigninAdmin.vue'),
  },
  {
    path: '/company/signup-admin',
    name: 'CreateAdmin',
    component: () => import('@/views/auth/CreateAdmin.vue'),
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPassword.vue'),
  },
  {
    path: '/reset-password-admin',
    name: 'ResetPasswordAdmin',
    component: () => import('@/views/auth/ResetPasswordAdmin.vue'),
  },
  {
    path: '/sso/login',
    name: 'SSOLogin',
    component: () => import('@/views/auth/SSOLogin.vue'),
  },
  {
    path: '/sso/reauth',
    name: 'SSOReauth',
    component: () => import('@/views/auth/SSOReauth.vue'),
  },
]

export default routes
